export const IPIP_NEO_120_QUESTIONS = [
  // Neuroticism (N)
  {
    domain: 'neuroticism',
    facet: 'anxiety',
    text: 'Worry about things.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'anger',
    text: 'Get angry easily.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'depression',
    text: 'Often feel blue.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'selfConsciousness',
    text: 'Am easily intimidated.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'immoderation',
    text: 'Often eat too much.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'vulnerability',
    text: 'Panic easily.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'anxiety',
    text: 'Am not easily bothered by things.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'anger',
    text: 'Rarely get irritated.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'depression',
    text: 'Seldom feel blue.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'selfConsciousness',
    text: 'Am comfortable in unfamiliar situations.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'immoderation',
    text: 'Am able to control my cravings.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'vulnerability',
    text: 'Remain calm under pressure.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'anxiety',
    text: 'Am relaxed most of the time.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'anger',
    text: 'Keep my cool.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'depression',
    text: 'Feel comfortable with myself.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'selfConsciousness',
    text: 'Am not easily embarrassed.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'immoderation',
    text: 'Rarely overindulge.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'vulnerability',
    text: 'Can handle a lot of stress.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    facet: 'anxiety',
    text: 'Get stressed out easily.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'anger',
    text: 'Get upset easily.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'depression',
    text: 'Have frequent mood swings.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'selfConsciousness',
    text: 'Am afraid of many things.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'immoderation',
    text: 'Go on binges.',
    reversed: false,
  },
  {
    domain: 'neuroticism',
    facet: 'vulnerability',
    text: 'Get overwhelmed by emotions.',
    reversed: false,
  },

  // Extraversion (E)
  {
    domain: 'extraversion',
    facet: 'friendliness',
    text: 'Make friends easily.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'gregariousness',
    text: 'Love large parties.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'assertiveness',
    text: 'Take charge.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'activityLevel',
    text: 'Am always on the go.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'excitementSeeking',
    text: 'Love excitement.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'cheerfulness',
    text: 'Radiate joy.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'friendliness',
    text: 'Am hard to get to know.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'gregariousness',
    text: 'Prefer to be alone.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'assertiveness',
    text: 'Wait for others to lead the way.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'activityLevel',
    text: 'Like to take it easy.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'excitementSeeking',
    text: 'Dislike taking risks.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'cheerfulness',
    text: 'Am not a very enthusiastic person.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'friendliness',
    text: 'Feel comfortable around people.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'gregariousness',
    text: 'Enjoy being part of a group.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'assertiveness',
    text: 'Can talk others into doing things.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'activityLevel',
    text: 'Do a lot in my spare time.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'excitementSeeking',
    text: 'Seek adventure.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'cheerfulness',
    text: 'Express my happiness.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    facet: 'friendliness',
    text: 'Often feel uncomfortable around others.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'gregariousness',
    text: 'Keep to myself.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'assertiveness',
    text: "Don't like to draw attention to myself.",
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'activityLevel',
    text: 'Am not very active.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'excitementSeeking',
    text: 'Would never go hang gliding or bungee jumping.',
    reversed: true,
  },
  {
    domain: 'extraversion',
    facet: 'cheerfulness',
    text: 'Am not easily amused.',
    reversed: true,
  },

  // Openness to Experience (O)
  {
    domain: 'openness',
    facet: 'imagination',
    text: 'Have a vivid imagination.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'artisticInterests',
    text: 'Believe in the importance of art.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'emotionality',
    text: 'Experience my emotions intensely.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'adventurousness',
    text: 'Prefer variety to routine.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'intellect',
    text: 'Like to solve complex problems.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'liberalism',
    text: 'Tend to vote for liberal political candidates.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'imagination',
    text: 'Do not have a good imagination.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'artisticInterests',
    text: 'Do not like poetry.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'emotionality',
    text: 'Rarely notice my emotional reactions.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'adventurousness',
    text: 'Dislike changes.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'intellect',
    text: 'Avoid philosophical discussions.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'liberalism',
    text: 'Tend to vote for conservative political candidates.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'imagination',
    text: 'Enjoy thinking about things.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'artisticInterests',
    text: 'Enjoy the beauty of nature.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'emotionality',
    text: 'Feel my own emotions.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'adventurousness',
    text: 'Am open to new experiences.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'intellect',
    text: 'Am interested in abstract ideas.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'liberalism',
    text: 'Believe that there is no absolute right or wrong.',
    reversed: false,
  },
  {
    domain: 'openness',
    facet: 'imagination',
    text: 'Am not interested in abstract ideas.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'artisticInterests',
    text: 'Do not enjoy going to art museums.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'emotionality',
    text: 'Do not understand people who get emotional.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'adventurousness',
    text: 'Am a creature of habit.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'intellect',
    text: 'Have difficulty understanding abstract ideas.',
    reversed: true,
  },
  {
    domain: 'openness',
    facet: 'liberalism',
    text: 'Believe that we should be tough on crime.',
    reversed: true,
  },

  // Agreeableness (A)
  {
    domain: 'agreeableness',
    facet: 'trust',
    text: 'Trust others.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'morality',
    text: 'Would never cheat on my taxes.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'altruism',
    text: 'Love to help others.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'cooperation',
    text: 'Am easy to satisfy.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'modesty',
    text: 'Dislike being the center of attention.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'sympathy',
    text: "Feel others' emotions.",
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'trust',
    text: "Am suspicious of others' intentions.",
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'morality',
    text: 'Use flattery to get ahead.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'altruism',
    text: 'Look out for myself first.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'cooperation',
    text: 'Can be stubborn.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'modesty',
    text: 'Boast about my virtues.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'sympathy',
    text: "Am not interested in other people's problems.",
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'trust',
    text: 'Believe that people are basically good.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'morality',
    text: 'Am not a very forgiving person.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'altruism',
    text: 'Make people feel welcome.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'cooperation',
    text: 'Hate to seem like a bother to others.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'modesty',
    text: 'Believe I am better than others.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'sympathy',
    text: "Suffer from others' sorrows.",
    reversed: false,
  },
  {
    domain: 'agreeableness',
    facet: 'trust',
    text: 'Believe that people have a dark side.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'morality',
    text: 'Know how to get around the rules.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'altruism',
    text: 'Am indifferent to the feelings of others.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'cooperation',
    text: 'Contradict others.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'modesty',
    text: 'Have a high opinion of myself.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    facet: 'sympathy',
    text: 'Try not to think about the needy.',
    reversed: true,
  },

  // Conscientiousness (C)
  {
    domain: 'conscientiousness',
    facet: 'selfEfficacy',
    text: 'Excel in what I do.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'orderliness',
    text: 'Like to tidy up.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'dutifulness',
    text: 'Keep my promises.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'achievementStriving',
    text: 'Go straight for the goal.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfDiscipline',
    text: 'Get chores done right away.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'cautiousness',
    text: 'Am careful to avoid making mistakes.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfEfficacy',
    text: 'Am not confident in my own abilities.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'orderliness',
    text: 'Often forget to put things back in their proper place.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'dutifulness',
    text: 'Find it difficult to get down to work.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'achievementStriving',
    text: 'Do just enough work to get by.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfDiscipline',
    text: 'Waste my time.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'cautiousness',
    text: 'Rush into things.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfEfficacy',
    text: 'Complete tasks successfully.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'orderliness',
    text: "Want everything to be 'just right'.",
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'dutifulness',
    text: 'Pay my bills on time.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'achievementStriving',
    text: 'Set high standards for myself and others.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfDiscipline',
    text: 'Have good control over my desires.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'cautiousness',
    text: 'Double-check my work.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfEfficacy',
    text: 'Misjudge situations.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'orderliness',
    text: 'Leave my belongings around.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'dutifulness',
    text: 'Break my promises.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'achievementStriving',
    text: 'Am not highly motivated to succeed.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'selfDiscipline',
    text: 'Have difficulty starting tasks.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    facet: 'cautiousness',
    text: 'Make rash decisions.',
    reversed: true,
  },
];

export const IPIP_NEO_50_QUESTIONS = [
  // Neuroticism
  { domain: 'neuroticism', text: 'Get stressed out easily.', reversed: false },
  {
    domain: 'neuroticism',
    text: 'Am relaxed most of the time.',
    reversed: true,
  },
  { domain: 'neuroticism', text: 'Worry about things.', reversed: false },
  { domain: 'neuroticism', text: 'Seldom feel blue.', reversed: true },
  { domain: 'neuroticism', text: 'Get upset easily.', reversed: false },
  {
    domain: 'neuroticism',
    text: 'Am not easily bothered by things.',
    reversed: true,
  },
  {
    domain: 'neuroticism',
    text: 'Have frequent mood swings.',
    reversed: false,
  },
  { domain: 'neuroticism', text: 'Rarely feel depressed.', reversed: true },
  { domain: 'neuroticism', text: 'Panic easily.', reversed: false },
  {
    domain: 'neuroticism',
    text: 'Remain calm under pressure.',
    reversed: true,
  },

  // Extraversion
  {
    domain: 'extraversion',
    text: 'Feel comfortable around people.',
    reversed: false,
  },
  { domain: 'extraversion', text: 'Keep to myself.', reversed: true },
  {
    domain: 'extraversion',
    text: 'Am the life of the party.',
    reversed: false,
  },
  {
    domain: 'extraversion',
    text: 'Am quiet around strangers.',
    reversed: true,
  },
  { domain: 'extraversion', text: 'Start conversations.', reversed: false },
  {
    domain: 'extraversion',
    text: "Don't like to draw attention to myself.",
    reversed: true,
  },
  {
    domain: 'extraversion',
    text: 'Talk to a lot of different people at parties.',
    reversed: false,
  },
  { domain: 'extraversion', text: "Don't talk a lot.", reversed: true },
  { domain: 'extraversion', text: 'Love large parties.', reversed: false },
  { domain: 'extraversion', text: 'Prefer to be alone.', reversed: true },

  // Openness
  { domain: 'openness', text: 'Have a rich vocabulary.', reversed: false },
  {
    domain: 'openness',
    text: 'Have difficulty understanding abstract ideas.',
    reversed: true,
  },
  { domain: 'openness', text: 'Have a vivid imagination.', reversed: false },
  {
    domain: 'openness',
    text: 'Am not interested in abstract ideas.',
    reversed: true,
  },
  { domain: 'openness', text: 'Have excellent ideas.', reversed: false },
  {
    domain: 'openness',
    text: 'Do not have a good imagination.',
    reversed: true,
  },
  {
    domain: 'openness',
    text: 'Am quick to understand things.',
    reversed: false,
  },
  { domain: 'openness', text: 'Have a poor vocabulary.', reversed: true },
  {
    domain: 'openness',
    text: 'Spend time reflecting on things.',
    reversed: false,
  },
  {
    domain: 'openness',
    text: 'Am not interested in theoretical discussions.',
    reversed: true,
  },

  // Agreeableness
  {
    domain: 'agreeableness',
    text: 'Am interested in people.',
    reversed: false,
  },
  { domain: 'agreeableness', text: 'Insult people.', reversed: true },
  {
    domain: 'agreeableness',
    text: "Sympathize with others' feelings.",
    reversed: false,
  },
  {
    domain: 'agreeableness',
    text: "Am not interested in other people's problems.",
    reversed: true,
  },
  { domain: 'agreeableness', text: 'Have a soft heart.', reversed: false },
  {
    domain: 'agreeableness',
    text: 'Am not really interested in others.',
    reversed: true,
  },
  {
    domain: 'agreeableness',
    text: 'Take time out for others.',
    reversed: false,
  },
  {
    domain: 'agreeableness',
    text: 'Feel little concern for others.',
    reversed: true,
  },
  { domain: 'agreeableness', text: "Feel others' emotions.", reversed: false },
  {
    domain: 'agreeableness',
    text: 'Make people feel at ease.',
    reversed: false,
  },

  // Conscientiousness
  { domain: 'conscientiousness', text: 'Am always prepared.', reversed: false },
  {
    domain: 'conscientiousness',
    text: 'Leave my belongings around.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    text: 'Pay attention to details.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    text: 'Make a mess of things.',
    reversed: true,
  },
  {
    domain: 'conscientiousness',
    text: 'Get chores done right away.',
    reversed: false,
  },
  {
    domain: 'conscientiousness',
    text: 'Often forget to put things back in their proper place.',
    reversed: true,
  },
  { domain: 'conscientiousness', text: 'Like order.', reversed: false },
  { domain: 'conscientiousness', text: 'Shirk my duties.', reversed: true },
  { domain: 'conscientiousness', text: 'Follow a schedule.', reversed: false },
  {
    domain: 'conscientiousness',
    text: 'Am exacting in my work.',
    reversed: false,
  },
];
